module.exports = __webpack_public_path__ + "img/CountryHeat.b2365780.jpg";